const env = process.env.NODE_ENV;

const development = {
    apiUrl: "https://api.myplay.com"
};
const production = {
    apiUrl: "https://api.myplay.com"
};

const config = {
    development,
    production
};

export default config[env];
